import React, { useMemo } from 'react';
import styled from 'styled-components';
import DropDown from '../../DropDown';
import BaseCheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';

const CheckBox = styled(BaseCheckBox)`
  flex: 1;
`;

const HelpDeskFlatMultiSelectFilter = ({
  name,
  options,
  selectedMap,
  onToggle,
  onApply,
  handleClose,
  hideLayout,
  search
}) => {
  const filteredOptions = useMemo(() => {
    if (!search?.trim()) return options;
    const lower = search.trim().toLowerCase();
    return options.filter(({ label }) => label && String(label).toLowerCase().includes(lower));
  }, [options, search]);

  return (
    <FilterLayout name={name} handleClose={handleClose} onApply={onApply} hideLayout={hideLayout}>
      {filteredOptions.map(({ key, label, value }) => (
        <DropDown.Item key={key}>
          <CheckBox
            name={`help-desk-filter-${key}`}
            value={!!selectedMap[key]}
            label={label}
            onChange={() => onToggle(key, value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default HelpDeskFlatMultiSelectFilter;
